import {useCallback, useEffect, useState} from 'react'
import feathers from 'utility/client'
import './style.css'
import {isObject} from 'lodash'

export const AutoComplete = props => {
  const {
    service,
    renderItem,
    onChange = () => {},
    headerTitle,
    renderHeader,
    onHeaderClick = () => {},
    // value object
    value,
    // Property to be displayed in input
    displayProperty = 'name',
    // Property needs to be used as value
    valueProperty = '_id',
    // Service query params
    query = {},
    // Search input props
    inputProps = {}
  } = props

  const [list, setList] = useState([])
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    console.log({
      service,
      renderItem,
      headerTitle,
      renderHeader,
      // value object
      value,
      // Property to be displayed in input
      displayProperty,
      // Property needs to be used as value
      valueProperty,
      // Service query params
      query,
      // Search input props
      inputProps,
    })
  }, [])

  useEffect(() => {
    if (!value) {
      return
    }

    if (isObject(value)) {
      setSearch(value[displayProperty])
    } else {
      try {
        feathers.service(service).get(value).then(data => {
          setSearch(data[displayProperty])
        })
      } catch (e) {
        onChange(undefined)
      }
    }
  }, [value])

  const fetch = useCallback(
    params => {
      return feathers.service(service).find(params)
    },
    [service]
  )

  const handleItemSelected = item => {
    setSearch(item[displayProperty])
    onChange({
      [displayProperty]: item[displayProperty],
      [valueProperty]: item[valueProperty]
    })
  }

  const handleInputBlur = e => {
    setTimeout(() => {
      setOpen(false)
    }, 100)
  }

  useEffect(() => {
    if (!search || !open) {
      return
    }

    setLoading(true)
    fetch({
      query: {
        [displayProperty]: {
          $regex: search,
          $options: 'i'
        },
        ...query,
        $limit: 50
      }
    })
      .then(result => {
        setList(result.data)
        console.log('Autocomplete Result', result.data)
      })
      .catch(console.error)
      .then(() => setTimeout(() => setLoading(false), 500))
  }, [search])

  const LeadingItemRenderer = useCallback(() => {
    if (headerTitle) {
      return <div className="option btn-link text-decoration-none" onClick={() => onHeaderClick()}>
        {headerTitle}
      </div>
    }

    if (renderHeader) return renderHeader()

    return null
  }, [headerTitle, onHeaderClick, renderHeader])

  const ItemRenderer = useCallback((item, index) => {
    if (renderItem) return renderItem(item, index)

    return <div className="option" onClick={() => handleItemSelected(item)} key={item._id}>
      {item[displayProperty]}
    </div>
  }, [displayProperty, renderItem])

  return (
    <div className="auto-complete-wrapper">
      <div className="input-wrapper">
        <input
          {...inputProps}
          value={search}
          className={`form-control ${open ? 'visible' : ''}`}
          onChange={e => setSearch(e.target.value)}
          onFocus={() => setOpen(true)}
          onBlur={handleInputBlur}
        />

        {
          loading && <div className="loading">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        }

      </div>
      <div className="auto-complete">
        <div className={`suggestions ${open ? 'visible' : ''}`}>
          { LeadingItemRenderer() }

          {list.map((item, index) => ItemRenderer(item, index))}
        </div>
      </div>
    </div>
  )
}
